import { Observable } from "rxjs";
import { TeleconsultaInterestInsertModel } from "../../models/comercial/teleconsulta-interest-insert.model";
import { ComercialRepository } from "../../repositories/comercial.repository";
import { UseCase } from "../../base/use-case";

export class InsertTeleconsultaInterestUseCase implements UseCase<{id:string,descripcion:string}, TeleconsultaInterestInsertModel> {
    constructor(private comercialRepository: ComercialRepository) { }
    execute(
        params: {id: string,descripcion: string},
    ): Observable<TeleconsultaInterestInsertModel> {
        return this.comercialRepository.insertTeleconsultaInterest(params);
    }
}
